import React from "react";
import Select from "react-select";

const MultiSelectLocation = (props) => {
  const { name, placeholder, data, defaultValueArr, setMultiSelectVal, } = props

  return (
    <div style={{ width: '275px' }}>
      <Select
        value={defaultValueArr ? defaultValueArr : null}
        name={name}
        closeMenuOnSelect={false}
        defaultValue={defaultValueArr}
        isMulti
        placeholder={placeholder}
        options={(data && data.length > 0) ? data : []}
        className="basic-multi-select"
        classNamePrefix="select"
        isSearchable={true}
        isDisabled={false}
        noOptionsMessage={() => "No records"}
        isClearable={true}
        onChange={(data, index) => setMultiSelectVal(data)}
      />
    </div>
  );
};
export default MultiSelectLocation;
